import { createUseStyles } from "@gfg/ui/theming";
import classnames from "classnames";
import { Table, TableCell, TableHead, TableRow } from "@gfg/ui/components/table";
import TableFilter from "common/components/table/table-filter";
import { SearchOptimizationStateTranslations } from "common/translations";
import { SearchOptimization, SearchOptimizationState } from "@coral/typings";
import TableFooter from "../../../common/components/table/table-footer";
import OptimizationsList from "./optimizations-list";
import SearchOptimizationStateMap from "~/common/constants/search-optimization-state";

const useStyles = createUseStyles(theme => ({
  tableContainer: {
    "boxShadow": theme.shadow("md"),
    "margin": theme.spacing(16),
    "& .tableBody tr": {
      borderTopColor: "transparent",
    },
  },
  headerCell: {
    color: theme.colors.black,
    background: theme.colors.white,
  },
  headerCellWithIcon: {
    display: "flex",
    alignItems: "center",
  },
}));

interface OptimizationsTableProps {
  searchOptimizations: SearchOptimization[] | undefined;
  total: number | undefined;

  onStateFilterChange(newValue: string): void;
  stateFilterValue: string;

  onOffsetChange(offset: number): void;
  offset: number;

  onLimitChange(limit: number): void;
  limit: number;

  onEditOptimization(optimization: SearchOptimization): void;
  onRemoveOptimization(optimization: SearchOptimization): void;
  onOptimizationStateChange(optimization: SearchOptimization, newState: SearchOptimizationState): void;
}

export default function OptimizationsTable({
  searchOptimizations,
  onStateFilterChange,
  stateFilterValue,
  onOffsetChange,
  onLimitChange,
  offset,
  total,
  limit,
  onEditOptimization,
  onRemoveOptimization,
  onOptimizationStateChange,
}: OptimizationsTableProps) {
  const classes = useStyles();

  return (
    <div>
      <Table block>
        <TableHead>
          <TableRow>
            <TableCell className={classnames(classes.headerCell)}>Search Query</TableCell>
            <TableCell className={classes.headerCell}>Contextual Suggestion</TableCell>
            <TableCell className={classes.headerCell}>Last Modified</TableCell>
            <TableCell className={classnames(classes.headerCell, classes.headerCellWithIcon)}>
              Status
              <TableFilter
                filters={Object.values(SearchOptimizationStateMap).map(value => ({
                  value,
                  label: SearchOptimizationStateTranslations[value],
                }))}
                onChange={onStateFilterChange}
                value={stateFilterValue}
              />
            </TableCell>
            <TableCell className={classes.headerCell} />
          </TableRow>
        </TableHead>
        {searchOptimizations && (
          <OptimizationsList
            optimizations={searchOptimizations}
            onEditOptimization={onEditOptimization}
            onRemoveOptimization={onRemoveOptimization}
            onOptimizationStateChange={onOptimizationStateChange}
          />
        )}
      </Table>
      <TableFooter
        onOffsetChange={onOffsetChange}
        offset={offset}
        total={total}
        limit={limit.toString()}
        onLimitChange={onLimitChange}
      />
    </div>
  );
}
